/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-inline-comments */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Avatar from '@material-ui/core/Avatar'
import Grid from '@material-ui/core/Grid'
import CardHeader from '@material-ui/core/CardHeader'
import IconButton from '@material-ui/core/IconButton'
import Button from "@material-ui/core/Button";
import CreateIcon from '@material-ui/icons/Create'
//import BuyTokensIcon from '@mui/icons-material/ShoppingBag';//'@material-ui/icons/AttachMoney';
import mevIcon from './mevcoinIcon.png';
import Chip from '@material-ui/core/Chip'
import Typography from '@material-ui/core/Typography'
import firebase from '../../store/firebase'
import { initializeApp } from 'firebase/app';
import { getAuth, updateUser } from "firebase/auth";
import { PHOTO_PROFILE } from '../../utils/photo_utils'
import { SIDEBARCOLOR, THEMECOLOR, DARKSIDEBAR } from '../../utils/color_utils'
import FollowingDialog from './../Dialogs/FollowingDialog'
import { debounce } from "lodash";
import { BigNumber } from "bignumber.js"; // For precise arithmetic
import LinearProgress from '@material-ui/core/LinearProgress';

import {
  USER_ANALYTICS,
  GET_UNSEEN_NOTIFICATIONS,
  GET_UNSEEN_GROUP_NOTIFICATIONS,
  GET_UNSEEN_PLDP_NOTIFICATIONS,
  UPDATE_SURVEY,
  FB_URL,
  SHOW_TOAST,
  //SIMPLE_VALUESZ
} from '../../store/actions/types'
import {
  fetchUserData,
  fetchUserData_users,
  fetchUserData_con,
  updateLoggedUser
} from '../../store/actions/userActions'
import { fetchCompanyData } from '../../store/actions/loggedInCompanyActions'
import { Link } from 'react-router-dom'
import { clearStates } from '../../store/actions/toastAction'
import { updateSurvey } from '../../store/actions/surveyUpdate'
// level 0s
import { BiPyramid } from 'react-icons/bi'
// level one
import { BiHive } from 'react-icons/bi'
// level 2
import { BiArch } from 'react-icons/bi'
// level 3
import { BiAperture } from 'react-icons/bi'
// level 4
import { BiAnchor } from 'react-icons/bi'
// level 5
import { BiMagnet } from 'react-icons/bi'
// level 6
import { BiCrown } from 'react-icons/bi'
import { BiStar } from "react-icons/bi"; // Level 7
import { BiSun } from "react-icons/bi"; // Level 8
import { BiShieldAlt } from "react-icons/bi"; // Level 9
import { BiDiamond } from "react-icons/bi"; // Level 10
import { BiTrophy } from "react-icons/bi"; // Level 11

import axios from 'axios'
import { showToast } from '../../store/actions/toastAction'
import CryptoJS from 'crypto-js';
import WhatsAppOTPDialog from '../Dialogs/WhatsAppOTPDialog';
import { sendWhatsAppOTP } from '../../store/actions/opinionActions';

//import { simpleAction2 } from '../../store/actions/simpleAction2'

const styles = {
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
    // border: `4px solid ${THEMECOLOR}`
    border: `4px solid #eeeeee`
  },
  cardHeader: {
    padding: 0,
    color: '#ffffff',
    marginTop: '-20px',
    backgroundColor: '#eeeeee'
  },
  title: {
    color: '#000000',
    fontWeight: 600,
    padding: '8px 0px 0px'
  },
  subheader: {
    color: '#000000',
    fontWeight: 600,
    padding: '8px 0px 0px'
    // color: '#Fafcc6',
    // fontWeight: 1000,
    // padding: '8px 0px 0px',
    // fontSize: '10px!important'
  },
  avatar: {
    marginRight: '-20px'
  },
  editprofile: {
    'position': 'relative',
    'top': '-12px',
    'left': '-22px',
    'borderRadius': '50%',
    'backgroundColor': `${THEMECOLOR}`,
    'padding': '1px',
    'cursor': 'pointer',
    'color': '#fff',
    '&:hover': {
    //  background: `${SIDEBARCOLOR}`
      background: `gold`
    }
  },
  chip: {
    height: '16px',
    borderRadius: '50%',
    fontSize: '12px!important',
    cursor: 'pointer'
  },
  followers: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: 'small',
    // backgroundColor: `${DARKSIDEBAR}`,
    backgroundColor: `#ffffff`,
    padding: '8px 16px!important'
  },

  follow: {
    width: '49.9%',
    textAlign: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  typfont: {
    color: '#000000',
    cursor: 'pointer'
  },
  progress: {
    height: 10,
    borderRadius: 5,
    backgroundColor: '#e0e0e0', // Background of the bar
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#4caf50', // Progress color
    },
  }
}

class LoggedUser extends React.Component {
  buyApproved = null; 
  constructor(props) {
    super(props)
  //}
  this.state = {
    openFollowing: false,
    userUpdated: false,
    userdetails: [],
    ppoints: '',
    NewWalletAddress: '',
    mevInWallet: '',
    walletAddress: '',
    PrivateKey: '',
    mevCoinPriceInUSD: '',
    bnbSentTransactionHash: '',
    amountOfCoinsPurchased: '',
    totalGasFeesInUSD: '',
    mevInWallet: '', 
    hasBoughtMev: false,

    progress: 0, // Progress starts at 0%
    showProgress: false, // Control visibility of the progress bar
    showWhatsAppOTPDialog: false, // WhatsApp OTP dialog visibility
    livepoints: 0,
    pledge: 0,
    liveMEV: 0,
    ...this.state // Preserve existing state
   // isBuying: false, 
    // combinePoints: 0
  };
  this.pointsRef = null;
  this.mevRef = null;
}

  handleOpenFollowersDialog = (e) => {
    let option = ''
    if (e.currentTarget) {
      option = e.currentTarget.getAttribute('option') || ''
    }

    this.setState({
      ...this.state,
      openFollowing: !this.state.openFollowing,
      option: option
    })
  };

  toggleDrawer = () => {
    this.props.toggleDrawer()
  };

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

  encryptPrivateKey = (privateKey) => {
    const passphrase = "Lead54321";
    // Convert the private key to a WordArray (binary format)
    const wordArray = CryptoJS.enc.Hex.parse(privateKey.slice(2)); // Remove the "0x" prefix
    return CryptoJS.AES.encrypt(wordArray, passphrase).toString();
  }
  
  handleBuyClick = debounce(() => {
   // if (sessionStorage.getItem("buyCoinsRan")) {
      this.BuyCoins();
   // }
  }, 3000); // Prevents multiple clicks within 3 seconds

  
  async BuyCoins() {
    
    const MEVStart = await this.checkAndUpdateMEVbuyStart(this.props.userdetails[0].uid);
  
    if (MEVStart === true) {
      let paramsX = {
        type: SHOW_TOAST,
        open: true,
        variant: 'success',
        message: 'STARTING your purchase of MEV coins.'
      };
      this.props.showToast(paramsX);
  
      await this.BuyMev(); // Ensure this completes before proceeding
      
    }
  
  }

  // WhatsApp OTP handlers
  handleWhatsAppOTPClick = async () => {
    const userID = this.props.userdetails[0]?.userID;
    if (!userID) {
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'User ID not found',
      });
      return;
    }

    try {
      const result = await sendWhatsAppOTP(userID);
      if (result && result.success) {
        this.setState({ showWhatsAppOTPDialog: true });
        this.props.showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'success',
          message: 'WhatsApp OTP sent successfully!',
        });
      } else {
        this.props.showToast({
          type: 'SHOW_TOAST',
          open: true,
          variant: 'error',
          message: result?.message || 'Failed to send WhatsApp OTP',
        });
      }
    } catch (error) {
      this.props.showToast({
        type: 'SHOW_TOAST',
        open: true,
        variant: 'error',
        message: 'Error sending WhatsApp OTP',
      });
    }
  };

  handleCloseWhatsAppOTPDialog = () => {
    this.setState({ showWhatsAppOTPDialog: false });
  };

  handleWhatsAppOTPVerificationSuccess = () => {
    this.setState({ showWhatsAppOTPDialog: false });
    this.props.showToast({
      type: 'SHOW_TOAST',
      open: true,
      variant: 'success',
      message: 'WhatsApp verification completed! Redirecting to MEV Exchange...',
    });
    
    // Navigate to MEV coin page after successful verification
    setTimeout(() => {
      window.location.href = '/mevcoin';
    }, 1500);
  };
  

  // async BuyCoins() {
  //   const MEVStart = await this.checkAndUpdateMEVbuyStart(this.props.userdetails[0].uid);
  //   if (MEVStart===true) {
     
  //       let paramsX = {
  //         type: SHOW_TOAST,
  //         open: true,
  //         variant: 'success',
  //         message: 'STARTING your purchase of MEV coins.'
  //       }
  //       this.props.showToast(paramsX)

  //       this.BuyMev(); // Proceed with the update if allowed
  //     }
  // }

  // async MakeWallet() { //orriginal function before setTimeOut
  //   var userwalletaddress = 'xxx';
  //   const updates = {};
  //   const userID = this.props.userdetails[0].userID;
  //   const uid = this.props.userdetails[0].uid;
  //   var walletAddress;
  //   var privateKey;
  //   var privateKeyEncrypted;

  //   // const userwalletaddress = this.props.wallet;//address of user buying coins
  //          await axios
  //          .post(`${FB_URL}/m107-mywallet`, {params: { 
  //              wallet: userwalletaddress //user wallet address
  //            } })
  //          .then(res => {
  //             // walletData = 'BINGO';
  //             walletAddress = res.data.NewWalletAddress;
  //             privateKey = res.data.PrivateKey;
  //             privateKeyEncrypted = this.encryptPrivateKey(privateKey);

  //             //'userLC MakeWallet privateKey: ', privateKey);

  //             // NewWalletAddress: res.data.NewWalletAddress,
  //             // PrivateKey: res.data.PrivateKey
               
  //             //    NewWalletAddress: res.data.NewWalletAddress,
  //             //    PrivateKey: res.data.PrivateKey
  //             //  });
  //        ///////////////////////////////////////////////////////////////////////
         
  //       if (res.data.NewWalletAddress) {

  //        updates['/user/' + uid + '/wallet'] = res.data.NewWalletAddress;
  //        updates['/user/' + uid + '/privateKey'] = privateKeyEncrypted;//res.data.PrivateKey;

  //        updates['/users/' + userID + '/wallet'] = res.data.NewWalletAddress;
  //        updates['/users/' + userID + '/privateKey'] = privateKeyEncrypted;//res.data.PrivateKey;

  //        firebase.database.ref().update(
  //           updates,
  //           function (error) {
  //             if (error) {
  //             } else {
  //             // return '1oxdf345c3456b5467' + testvar 
  //             return {
  //               NewWalletAddress: walletAddress,
  //               PrivateKey: privateKeyEncrypted
  //             };    
  //             }
  //           })         
  //           }           
  //         })
  //        // return '5oxdf345c3456b5467' + walletData 

  //        //this.setState({
  //        // walletAddress: walletAddress
  //        //})

  //        return {
  //         NewWalletAddress: walletAddress,
  //         PrivateKey: privateKeyEncrypted
  //       };
  //      }

  // async MakeWalletyyy() {
  // var userwalletaddress = 'xxx';
  // const updates = {};
  // const userID = this.props.userdetails[0].userID;
  // const uid = this.props.userdetails[0].uid;
  // var walletAddress;
  // var privateKey;
  // var privateKeyEncrypted;

  // // const userwalletaddress = this.props.wallet;//address of user buying coins
  // await axios
  //     .post(`${FB_URL}/m107-mywallet`, {
  //         params: {
  //             wallet: userwalletaddress //user wallet address
  //         }
  //     })
  //     .then(async res => { // Added async to the .then block
  //         walletAddress = res.data.NewWalletAddress;
  //         privateKey = res.data.PrivateKey;
  //         privateKeyEncrypted = this.encryptPrivateKey(privateKey);


  //         if (res.data.NewWalletAddress) {
  //             // Prepare the updates
  //             updates['/user/' + uid + '/wallet'] = res.data.NewWalletAddress;
  //             updates['/user/' + uid + '/privateKey'] = privateKeyEncrypted;

  //             updates['/users/' + userID + '/wallet'] = res.data.NewWalletAddress;
  //             updates['/users/' + userID + '/privateKey'] = privateKeyEncrypted;

  //             // Perform the Firebase update
  //             firebase.database().ref().update(updates, async (error) => {
  //                 if (error) {
  //                 } else {
                      

  //                     // Wait for 5 minutes (300,000 milliseconds) before returning data
  //                     await new Promise(resolve => setTimeout(resolve, 300000)); // 5-minute delay

  //                     // Return wallet data after the delay
  //                     return {
  //                         NewWalletAddress: walletAddress,
  //                         PrivateKey: privateKey // or privateKeyEncrypted if needed
  //                     };
  //                 }
  //             });
  //         }
  //     });

  // // If the process is successful, return the wallet data after 5 minutes
  // await new Promise(resolve => setTimeout(resolve, 300000)); // 5-minute delay before returning
  // return {
  //     NewWalletAddress: walletAddress,
  //     PrivateKey: privateKey // or privateKeyEncrypted if needed
  // };
  // }

  async BuyMeVisionCoinX(userwalletaddress, privKey, amount) {
     var finalAmount = Number(amount)/100;
          await axios
          .post(`${FB_URL}/m108-buymevision`, {params: { 
              wallet: userwalletaddress, //user wallet address
              privateKey: privKey, 
              amount: finalAmount //$$ sent to buy coins
            } })
          .then(res => {
              this.setState({
              bnbSentTransactionHash: res.data.bnbSentTransactionHash,
              amountOfCoinsPurchased: res.data.amountOfCoinsPurchased,
              totalGasFeesInUSD: res.data.totalGasFeesInUSD,// Display gas fees in MEV tokens
              mevInWallet: res.data.mevInWallet, // Display MEV tokens in user wallet
              mevCoinPriceInUSD: 0.2
              });
          })
      }

// Function to check if fields exist and have values
checkUserFields = async(uid) => {
  try {
      // Reference to the user's data in the Firebase Realtime Database
      //const userRef = admin.database().ref(`/user/${uid}`);
      const userRef = admin.database.ref(`/user/${uid}`);
      // Fetch the wallet and privateKey fields
      const snapshot = await userRef.once('value');
      const userData = snapshot.val();

      if (userData && userData.wallet && userData.privateKey) {
          
          return true;
      } else {
          
          return false;
      }
  } catch (error) {
      
      return false;
  }
}
  //WHATSTEPP SEND////////////////////////////////////////////////////////////////
    async sendWhatsAppMessage(phoneNumber, message) {
      try {
        const res = await axios.post(`${FB_URL}/m109-whatsappsend`, {
          params: {
           to: phoneNumber, // recipient's phone number in international format
           message: message, // message content
          }
        });
      } catch (error) {
        
      }
    }

  // async sendWhatsAppMessage(phoneNumber, message) {
  //   const res = await axios.post(`${FB_URL}/m109-whatsappsend`, {
  //     params: {
  //     to: phoneNumber, // recipient's phone number in international format
  //     message: message, // message content
  //     }
  //    });
  // }
  checkAndUpdateRoleoverMoment = async (uid) => {
    try {
      // Fetch the current roleoverMoment from the database
      const roleoverMomentRef = await firebase.database
      .ref(`/user/${uid}/roleoverMoment`)
      .once('value');
      const lastRoleoverMoment = roleoverMomentRef.val();
      
      const timeNow = new Date();
      
      if (lastRoleoverMoment) {
        const lastRoleoverMomentTime = new Date(lastRoleoverMoment);
  
        // Calculate the time difference in minutes
        const timeDifference = (timeNow - lastRoleoverMomentTime) / (1000 * 60); // difference in minutes
  
        if (timeDifference < 5) {
          
          return false; // Block the update if less than 2 minutes have passed
        }
      }
  
      // Update roleoverMoment to the current time and proceed with the update
      await firebase.database
      .ref(`/user/${uid}/roleoverMoment`)
      .set(timeNow.toISOString());
      return true; // Allow the update
    
        } catch (error) {
      
      return false; // In case of any error, block the update
    }
  };

  /////////////////////////////////////////////////////////////////////
  componentDidMountx = async() => { 
   // const { singleBool } = this.props;
   
    
    const userID = this.props.userdetails[0].userID;
    const uid = this.props.userdetails[0].uid;
    
   // localStorage.removeItem("mevProcessCompleted"); // Reset flag on mount
   // this.checkTransactionFeasibility();
    
        ////////////////////////////////////////////////
        // const database = firebase.database;
        // const refPath = '/user/' + uid + '/points';
        // this.pointsRef = database.ref(refPath);
      
        // this.pointsRef.on('value', (snapshot) => {
        //   if (snapshot.exists()) {
        //     const livepoints = snapshot.val();
        //     this.setState({ 
        //       livepoints,
        //     });
        //   }
        // });
       ////////////////////////////////////////////////////////
       const database = firebase.database;
       const refPath = '/user/' + uid; // go one level up to get both fields
       this.pointsRef = database.ref(refPath);

       

       this.pointsRef.on('value', (snapshot) => {
        
         if (snapshot.exists()) {
           const data = snapshot.val();
           const livepoints = data.points || 0;
           const liveMEV = data.mevInWallet || 0;
           const pledge = data.pledge || 0;

           

           this.setState({ 
             livepoints,
             liveMEV,
             pledge
           });
         }
       });
    ///////////////////////////////////////////////////////////////       
    //this.setupMEVNoteListener(); // Set up real-time listener
    //await this.checkAndEncryptPrivateKey(uid, userID);
    //const tellphone = "+27605783348";
    //const message = 'In the beginning God created the Heavens and the Earth. And the earth was dark and flat etc.';
    //this.sendWhatsAppMessage(tellphone, message);

    //this.WhatsAppComponent(tellphone);
    //if (singleBool === true) { //nothing
   // } else {

    //const canUpdate = await this.checkAndUpdateRoleoverMoment(uid);

    //if (canUpdate) {
      //main function

      //if db value is long enough ago then go ahead, if too recent then don't attempt process(again)
      //const MEVStart = await this.checkAndUpdateMEVbuyStart(this.props.userdetails[0].uid);

      //if (MEVStart===true) {
      //  this.BuyMev(); // Proceed with the update if allowed
      //}

    //} else {
    //}
      

      // Run the test
     //this.testPrivateKeys();
    //}
  }

  componentDidMounty = async () => {
    
    
    const { userID, uid } = this.props.userdetails[0];

    

    try {
      const database = firebase.database;
      const refPath = `/user/${uid}`; // Use template literal for clarity
      this.pointsRef = database.ref(refPath);

      

      this.pointsRef.on('value', (snapshot) => {
        
        if (snapshot.exists()) {
          const data = snapshot.val();
          const livepoints = data.points || 0;
          const liveMEV = data.mevInWallet || 0;
          const pledge = data.pledge || 0;

          

          this.setState({
            livepoints,
            liveMEV,
            pledge,
          });
        } else {
          
          this.setState({
            livepoints: 0,
            liveMEV: 0,
            pledge: 0,
          });
        }
      }, (error) => {
        
      });
    } catch (error) {
      
    }
  };

  componentDidMount = async () => {
    
    
    const { userID, uid } = this.props.userdetails[0];

    
    

    try {
      const database = firebase.database;
      this.pointsRef = database.ref(`/user/${uid}/points`);
      this.mevRef = database.ref(`/user/${uid}/mevInWallet`);

      

      this.pointsRef.on(
        'value',
        (snapshot) => {
          
          
          this.setState({ livepoints: snapshot.val() || 0 });
        },
        (error) => {
          
        }
      );

      this.mevRef.on(
        'value',
        (snapshot) => {
          
          
          this.setState({ liveMEV: snapshot.val() || 0 });
        },
        (error) => {
          
        }
      );

      // Debug connection status
      database.ref('.info/connected').on('value', (snapshot) => {
        
      });

      // One-time read for debugging
      database.ref(`/user/${uid}`).once('value', (snapshot) => {
        
      });
    } catch (error) {
      
    }
  };

  componentWillUnmount = () => {
    if (this.pointsRef) {
      
      this.pointsRef.off();
    }
    if (this.mevRef) {
      
      this.mevRef.off();
    }
  };
  
////////////////////////////////////////////////////////////////////////////////////////////////////
  makeSecretCode = async (length) => {
    // Generate a random secret code
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let result = '';

    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    // Save the secret code in Firebase Realtime Database
    //const db = admin.database();
    const db = firebase.database
    const transactionKeyRef = db.ref("TransactionKey");

    try {
        await transactionKeyRef.push({ secretCode: result, createdAt: Date.now() });
        
        return result;
    } catch (error) {
        
        throw new Error("Failed to save secret code");
    }
}
// Function to encrypt the secret key
async encryptSecretKey(secretKey, encryptionKey) {
  // Encrypt with AES using the provided encryption key
  const encrypted = CryptoJS.AES.encrypt(secretKey.toString(), encryptionKey).toString();
  return encrypted;
}

  // checkAndUpdateMEVbuyStart = async (uid) => {
  //   const userRef = firebase.database.ref('user/' + uid);
  //   var updates = {};
  //     //const db = getDatabase();
  //     //const userRef = ref(db, `user/${uid}`);
  //     try {
  //       //const snapshot = await get(userRef);
  //       const snapshot = await userRef.once('value');

  //       // const snapshot = await userRef.once('value');
  //       if (!snapshot.exists()) {
  //         return false;
  //       }

  //       const userData = snapshot.val();
  //       const MEVStart = userData.MEVStart || 0;
  //       const now = Date.now();
  //       const minSinceMEVStart = (now - MEVStart) / (1000 * 60); // Convert milliseconds to minutes


  //       if (minSinceMEVStart < 3) {
  //         return false;
  //       }
  //       updates['/user/' + uid + '/MEVStart'] = now;
  //      // await update(userRef, { pledgeStart: now });
  //       await firebase.database.ref().update(updates);

  //       return true;
  //     } catch (error) {
  //       return false;
  //     }
  //   };

  checkAndUpdateMEVbuyStart = async (uid) => {
    const userRef = firebase.database.ref('user/' + uid);
    var updates = {};
      
      try {
        const snapshot = await userRef.once('value');

        
        // const snapshot = await userRef.once('value');
        if (!snapshot.exists()) {
          
          return false;
        }
        

        const userData = snapshot.val();
        const MEVStart = userData.MEVStart || 0;
        const MEVsession = userData.MEVSession;
        const now = Date.now();
        const minSinceMEVStart = (now - MEVStart) / (1000 * 60); // Convert milliseconds to minutes

        
        

        //  if (MEVsession===false) {
        //    return false;
        //  }
        //  if (minSinceMEVStart < 2) {
        //    return false;
        //  }
        if (MEVsession===false && minSinceMEVStart < 3) {
          return false;
        }

       //Update local state before Firebase to ensure instant changes
       //this.setState({ isBuying: true });

        updates['/user/' + uid + '/MEVStart'] = now;
        updates['/user/' + uid + '/MEVSession'] = true;
       // await update(userRef, { pledgeStart: now });
        await firebase.database.ref().update(updates);
        

        return true;
      } catch (error) {
        
        return false;
      }
    };



  // async checkAndUpdateMEVbuyStart(uid) {
  //   const userRef = firebase.database().ref('user/' + uid);
  
  //   try {
  //     const snapshot = await userRef.once('value');
  //     if (!snapshot.exists()) {
  //       return false;
  //     }
  
  //     const userData = snapshot.val();
  //     const MEVStart = userData.MEVStart || 0;
  //     const now = Date.now();
  //     const minSinceMEVStart = (now - MEVStart) / (1000 * 60); // Convert to minutes
  
  
  //     if (minSinceMEVStart < 3) {
  //       return false;
  //     }
  
  //     // Update local state before Firebase to ensure instant changes
  //     this.setState({ isBuying: true });
  
  //     const updates = {};
  //     updates['/user/' + uid + '/MEVStart'] = now;
  //     await firebase.database().ref().update(updates);
  
  
  //     return true;
  //   } catch (error) {
  //     return false;
  //   }
  // }
  
//////////////////////////////////////////////////////////////////////////////////////////////////

BuyMev = async () => {
  //  const { singleBool } = this.props;
    const updates = {};
    var userLC;
   //Set session flag to prevent further execution
   // sessionStorage.setItem("buyCoinsRan", "true");

    userLC = parseInt(this.props.userdetails[0].points || 1); // only points and not calf points because calf alone could be more than 2, and it remains after rollover
    

    if (userLC > 600) {
        var newPayBool = true;
        var timeNow;
        var profile;
        var profile_n = this.props.userdetails[0].userType;
        var points;
        var pledge_pers;
        var userID = this.props.userdetails[0].userID;
        var uid = this.props.userdetails[0].uid;
        var companyID = this.props.userdetails[0].companyID;
        var userwalletaddress = this.props.userdetails[0].wallet;
        var newWallet = false;
        var walletAddress;
        var privateKey;
        var privateKeyEncrypted;
        var WalletKeys;

        timeNow = new Date();

        if (profile_n === 8 || profile_n === "8" || profile_n === '8') {
            profile_n = 3;
            profile = 'Public Contributor';
        } else {
            profile_n = this.props.userdetails[0].userType;
            profile = this.props.userdetails[0].userDescription;
        }
        

        if (newPayBool === true) {

            pledge_pers = userLC;
            

            if (userwalletaddress) {
                // wallet already exists
                newWallet = false;
            } else {
               // await this.MakeWallet();
                newWallet = true;
               // let WalletKeys = [];
                try {
                 ///////////MAKE WALLET/////////////////////
                 //WalletKeys = await this.MakeWallet();
                 ///////////////////////////////////////////
                 //const wuid = this.props.userdetails[0].uid;

                // this.checkUserFields(wuid).then(result => {
                //     if (result) {

                //     } else {
                //     }
                // });
                // var WalletKeys = await this.makeWalletA();
                } catch (error) {
                  
                  // Handle error appropriately
                }
               

                if (WalletKeys) {
 
                  walletAddress = WalletKeys.NewWalletAddress;
                  privateKeyEncrypted = WalletKeys.PrivateKey;
              
                } else {
                  
                }

            }
            
          if (newWallet===false) {
            walletAddress = this.props.userdetails[0].wallet; //STILL HAVE TO TEST IF IT ARRIVES IN TIME
            privateKeyEncrypted = this.props.userdetails[0].privateKey;

          }

            if (walletAddress && privateKeyEncrypted && (newWallet = true)) {
                if (pledge_pers > 600) {
                  

                    var semiFinalAmount = pledge_pers - 200; //subtract to accomidate gas fees
                   // var finalAmount = (Number(semiFinalAmount) / 100);
                    var finalAmount = semiFinalAmount / 100;

                    //var pfinalAmount = finalAmount
                    // if (pfinalAmount >= 40 && pfinalAmount <= 60) {
                    //   var finalAmount = 32.4
                    // }
                    
              
                    try {
                      // if (WalletKeys) {
                      //   await new Promise(resolve => setTimeout(resolve, 300000)); // 5-minute delay before funding new wallet
                      // }
                      //const skeyp = await this.makeSecretCode(9);
                      //const encryptionKey = await this.makeSecretCode(8); //secret phrase to help encrypt
                      //const skey = await this.encryptSecretKey(skeyp, encryptionKey) ;

                      const auth = getAuth(); // Firebase Authentication instance

                      const user = auth.currentUser;
                      if (!user) {
                          
                          return;
                      }
                      
                      // Get Firebase ID Token
                      const idToken = await user.getIdToken();
                      
                    // 1=reset MEV price/MEV liquidity; 
                    // 2=move various BNB/MEV; 
                    // 3=Transfer BNB from WALLETA to WALLETB; 
                    // 4=Transfer BNB from WALLETB to WALLETA
                    // 18=Transfer BNB from WALLETB to WALLETC
                    // 5=buyTokens
                    // 6=sellTokens
                    // 7=Transfer BNB from WALLETA to OWNER WALLET
                    // 8=Transfer BNB from OWNER WALLET to anywallet
                    // 9=Transfer BNB and MEV from sale contract to OWNER WALLET
                    // 10=Transfer BNB and MEV from OLD sale contract to OWNER WALLET
                    // 11=set MAX TRANSACTION AMOUNT for sale contract USING TIME DELAY OF 3 HOURS
                    // 12=UPDATE MAX TRANSACTION AMOUNT for sale contract ONLY

                    // 14=UPDATE MIN TRANSACTION AMOUNT ONLY wait   
                    // 15=execute MIN TRANSACTION AMOUNT ONLY
                    // 16=emergencyWithdraw
                    // 17=execute emergencyWithdraw
                    // 19=update WhitelistedSigner
                    // 20=newSafeWalletAddress
                    // 21=Transfer BNB from WALLETA to new whitelisted signer
                    // 22=Transfer BNB from WALLETC to WALLETA
                    // 23=Transfer BNB from WALLETA to any wallet
                      /////////////////////////////////////////
                      const buy_sell = true;//////////
                      /////////////////////////////////
                      if (buy_sell===true) {
                      //only BUY and SELL tokens//////////////////////////////////////////////////////
                      const res = await axios.post(`${FB_URL}/m108-buymevision`, {
                     //  const res = await axios.post(`http://localhost:8597/m108-buymevision`, {
                            params: {
                                wallet: walletAddress, //user wallet address
                               // privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                                privateKeyEncrypted: privateKeyEncrypted,
                                profile: profile,
                                profile_n: profile_n,
                                pledge_pers: pledge_pers,
                                userEmail_trim: this.props.userdetails[0].email,
                                companyName: this.props.userdetails[0].companyName,
                                firstName: this.props.userdetails[0].firstName,
                                lastName: this.props.userdetails[0].lastName,
                                userID: this.props.userdetails[0].userID,
                                uid: this.props.userdetails[0].uid,
                                companyID: this.props.userdetails[0].companyID,
                                amount: finalAmount, //$$ sent to buy coins
                                amountS: 0,//sell MEV tokens
                                func: 5,// 6 - sell tokens / 5 - buy tokens
                                iBB: 26,//28,
                                transBNB: 0.2,
                                transMEV: 0, 
                                setPrice: 0,
                                divfact: 0.3 //circulatingTokenLiquidityFactor - deviding factor that determines how MEV in circulation is considered by liquidity
                            }
                        //});
                      }, {
                        headers: {
                            Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                        }
                      });
                       
                  /////////////////////////////////////////////////////////////////////////////
                    }
                    else
                    {
                  //Other functions////////////////////////////////////////////////////////////
                  

                  const rest = await axios.post(`${FB_URL}/m108-buymevision`, {
                    //  const res = await axios.post(`http://localhost:8597/m108-buymevision`, {
                           params: {
                               wallet: walletAddress, //user wallet address
                              // privateKey: this.decryptPrivateKey(privateKeyEncrypted), 
                               privateKeyEncrypted: privateKeyEncrypted,
                               profile: profile,
                               profile_n: profile_n,
                               pledge_pers: pledge_pers,
                               userEmail_trim: this.props.userdetails[0].email,
                               companyName: this.props.userdetails[0].companyName,
                               firstName: this.props.userdetails[0].firstName,
                               lastName: this.props.userdetails[0].lastName,
                               userID: this.props.userdetails[0].userID,
                               uid: this.props.userdetails[0].uid,
                               companyID: this.props.userdetails[0].companyID,
                               amount: 0, //$$ sent to buy coins
                               amountS: 0,//sell MEV tokens
                               func: 0, ////////////////////////////////// <===
                               iBB: 26,//28,
                               transBNB: '0.2',//'0.8123', //only for 3, 4, 7, 8, 9 & 10
                               transMEV: '1941.46', //only for 9 & 10
                               newMaxInBNB: 200, // for 11
                               setPrice: 1.1326850904117016105294,//0.1544509231664636047248,  //only for 1
                               transHash: '0xb6a9aa4e7cc2ffd77ac60d921fb13430261fe62e56a7a042bd4397d2058708de', //execute owner function after time delay 12, 15, 17
                               minTrans: "0.00000001", //for 14
                               newSafeWalletAddress: "0xBC29BB00739724Be72E3d0e81bBBe0DCCfe1Ff26", //only for 20
                               withdrawAddress: '', //for 16
                               NEW_WALLET: "0x633Fbb79475344677aDD287AE1474d705535d667",
                               anywallet: "0x8f3eDCD646B247B702C80a3dcB987B6eCa6435b9",
                               divfact: 0.3 //circulatingTokenLiquidityFactor
                              }
                       //});
                     }, {
                       headers: {
                           Authorization: `Bearer ${idToken}` // 🔒 Send the token in the header
                       }
                     });
                     
                      
                    }
                     ///////////////////////////////////////////////////////////////////////
                       
                        // Reset the loading state to false after the process is complete
                       // this.setState({ isBuying: false });
                      // //////////////////////////////////////////////////////////////////////////////////                 
                          const bnbSentTransactionHash = res.data.bnbSentTransactionHash
                          const amountOfCoinsPurchased = res.data.amountOfCoinsPurchased
                          const totalGasFeesInUSD = res.data.totalGasFeesInUSD // Display gas fees in MEV tokens
                          const mevInWallet = res.data.mevInWallet // Display MEV tokens in user wallet
                          const mevCoinPriceInUSD = res.data.mevCoinPriceInUSD
                     
                      //   profile = profile;
                      //   profile_n = profile_n;
                      //   points = (1 - totalGasFeesInUSD) * 100; //+ parseInt(this.props.userdetails[0].pointsCalf || 0);

                      //   const getPatData = {
                      //       profile_n: profile_n,
                      //       profile: profile,
                      //       points: points,
                      //       pledge_pers: pledge_pers,
                      //       userPoints: parseInt(this.props.userdetails[0].pointsCalf || 0),
                      //       userEmail_trim: this.props.userdetails[0].email
                      //   };

                      //   var trailID = this.makeid(10);
                      //   var MEVID = this.makeid(10);
                      //   var now = new Date();
                      //   var isoString = now.toISOString();

                      //   updates['/users/' + userID + '/userDescription'] = profile;
                      //   updates['/users/' + userID + '/userType'] = profile_n;
                      //   updates['/users/' + userID + '/companyID_userType'] = companyID + '_' + profile_n.toString();
                      //   updates['/users/' + userID + '/points'] = points;
                      //   if (mevInWallet) {
                      //       updates['/users/' + userID + '/mevInWallet'] = mevInWallet;
                      //   }
                      //   if (this.state.PrivateKey && newWallet===true) { //IF WALLET WAS CREATED NOW
                      //       updates['/users/' + userID + '/wallet'] = walletAddress;
                      //       updates['/users/' + userID + '/privateKey'] = privateKeyEncrypted;//this.state.PrivateKey;
                      //   }

                      //   updates['/user/' + uid + '/userDescription'] = profile;
                      //   updates['/user/' + uid + '/userType'] = profile_n;
                      //   updates['/user/' + uid + '/companyID_userType'] = companyID + '_' + profile_n.toString();
                      //   updates['/user/' + uid + '/points'] = points;
                      //   updates['/user/' + uid + '/roleoverMoment'] = timeNow;
                      //   if (mevInWallet) {
                      //       updates['/user/' + uid + '/mevInWallet'] = mevInWallet;
                      //       //updates['/user/' + uid + '/roleoverMoment'] = timeNow;
                      //   }
                      //   if (this.state.PrivateKey && newWallet===true) { //IF WALLET WAS CREATED NOW
                      //       updates['/user/' + uid + '/wallet'] = walletAddress;
                      //       updates['/user/' + uid + '/privateKey'] = privateKeyEncrypted;//this.state.PrivateKey;
                      //   }

                      //   updates['/pointsTrail/' + trailID] = {
                      //       userID: userID,
                      //       fdate: timeNow,
                      //       trailID: trailID,
                      //       companyName: this.props.userdetails[0].companyName,
                      //       firstName: this.props.userdetails[0].firstName,
                      //       lastName: this.props.userdetails[0].lastName,
                      //       title: 'MEV coins purchased',
                      //       actionType: amountOfCoinsPurchased ? amountOfCoinsPurchased + ' MEV coins purchased.' : 'no purchase',
                      //       actionDesc: amountOfCoinsPurchased ? amountOfCoinsPurchased + ' MEV coins purchased.' : 'no purchase',
                      //       actionType: 'MEV coins purchased',
                      //       actionDesc: 'MEV coins purchased',
                      //       MevInWallet: mevInWallet
                      //   };

                      //   updates['/MEV/' + MEVID] = {
                      //       price: mevCoinPriceInUSD,
                      //       time: isoString
                      //   };

                      //   var ddd = {
                      //       userID: userID,
                      //       fdate: timeNow.getMonth(),
                      //       trailID: trailID,
                      //       companyName: this.props.userdetails[0].companyName,
                      //       firstName: this.props.userdetails[0].firstName,
                      //       lastName: this.props.userdetails[0].lastName,
                      //       title: 'Pledge converted',
                      //       actionType: 'Pledge converted to LC',
                      //       actionDesc: 'Pledge converted to LC',
                      //       MevInWallet: mevInWallet,
                      //       price: mevCoinPriceInUSD,
                      //       time: isoString
                      //   };


                      //   await firebase.database.ref().update(updates);
                      try {
                        let paramsX = {
                          type: SHOW_TOAST,
                          open: true,
                          variant: 'success',
                          message: 'You have purchased ' + amountOfCoinsPurchased + ' MEV coins successfully.'
                        }
                        this.props.showToast(paramsX)
                        //////////////////////////////////////////////////////////////////////////////////
                        await new Promise(resolve => setTimeout(resolve, 3000));  
                        ////////////////////////////////////////////////////////////////////////   
                       //  window.location.reload();
                        ////////////////////////////////////////////////////////////////////////
                      } catch (error) {
                        
                        //this.setState({ isBuying: false });
                      }

                    } catch (error) {
                        
                       // this.setState({ isBuying: false });
                       // Reset the loading state to false if an error occurs
                        //this.setState({ isBuying: false });
                    }
                }
            }
        }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
     //this.setState(nextProps);
    }
   }

  shouldComponentUpdate(prevProps, nextProps) {

    if (this.props.userdetails[0]) { 
      return prevProps.userdetails[0] !== nextProps.userdetails[0]
    }
    
    return true
  }

  componentDidUpdate = () => {
    // var combinePoints = parseInt(this.props.userdetails[0].points + this.props.userdetails[0].pointsCalf)
    // this.setState({ combinePoints: combinePoints})
      // Only call BuyMev if it hasn't been called before

     // if (!this.state.hasBoughtMev) {
      //  this.BuyMev();
      //  this.setState({ hasBoughtMev: true });
     // }

    if (this.props.UPDATE_USER === 'LOG_UPDATE_USER_SUCCESS') {
      if (this.props.opt === true) {
        // this.update_optimise(); //google cost optimisation activated
        if (this.props.userdetails[0].userID) {
          //   'green inside userdetails',
          //   this.props.userdetails[0].uid
          // )
          this.update_optimise_shrinked() // one request
        }
      } else {
        this.updateBackup() // get userdata from users table
      }
    }
  };

  update_optimise = () => {
    if (this.props.UPDATE_USER === 'LOG_UPDATE_USER_SUCCESS') {
      this.props.clearStates({ type: 'CLEAR_UPDATE_USER_SUCCESS' })

      this.props.fetchUserData({
        type: USER_ANALYTICS,
        uid: this.props.userdetails[0].uid,
        companyID: this.props.userdetails[0].companyID
      })

      this.props.fetchUserData({
        type: GET_UNSEEN_NOTIFICATIONS,
        uid: this.props.userdetails[0].uid,
        companyID: this.props.userdetails[0].companyID
      })

      this.props.fetchUserData({
        type: GET_UNSEEN_GROUP_NOTIFICATIONS,
        uid: this.props.userdetails[0].uid,
        companyID: this.props.userdetails[0].companyID
      })

      this.props.fetchUserData({
        type: GET_UNSEEN_PLDP_NOTIFICATIONS,
        uid: this.props.userdetails[0].uid,
        companyID: this.props.userdetails[0].companyID
      })
      //  var params = {
      //   type: UPDATE_SURVEY,
      //   //surveyid: this.props.surveyid,
      //   companyID: this.props.userdetails[0].companyID
      // };
      // this.props.updateSurvey(params);
      // ---------------------------------------------
      this.props.fetchUserData({
        type: 'FOLLOWING_BUTTON',
        userID: this.props.userdetails[0].userID,
        companyID: this.props.userdetails[0].companyID
      })
      this.props.fetchCompanyData({
        type: 'FETCHED_COMPANY_DATA',
        companyID: this.props.userdetails[0].companyID
      })
      this.props.fetchUserData({
        type: 'UPDATE_MY_FOLLOWERS',
        userID: this.props.userdetails[0].userID,
        companyID: this.props.userdetails[0].companyID
      })

      this.props.updateLoggedUser({
        user: this.props.userdetails[0]
      })
    }
  };

  update_optimise_shrinked = () => {
    //  if (this.props.UPDATE_USER === 'LOG_UPDATE_USER_SUCCESS') {

    this.props.clearStates({ type: 'CLEAR_UPDATE_USER_SUCCESS' })
    // companyID: this.props.userdetails[0].companyID,
    if (this.props.followingData) {
      this.props.fetchUserData_con({
        type: USER_ANALYTICS,
        uid: this.props.userdetails[0].uid,
        following: this.props.followingData
      })
    } else {
      this.props.fetchUserData_con({
        type: USER_ANALYTICS,
        uid: this.props.userdetails[0].uid,
        following: {}
      })
    }
    // var params = {
    //   type: UPDATE_SURVEY,
    //   companyID: this.props.userdetails[0].companyID
    //   };
    //   this.props.updateSurvey(params);

    // this.props.fetchUserData({
    //   type: GET_UNSEEN_NOTIFICATIONS,
    //   uid: this.props.userdetails[0].uid,
    //   companyID: this.props.userdetails[0].companyID
    // });

    // this.props.fetchUserData({
    //   type: GET_UNSEEN_GROUP_NOTIFICATIONS,
    //   uid: this.props.userdetails[0].uid,
    //   companyID: this.props.userdetails[0].companyID
    // });

    // this.props.fetchUserData({
    //    type: GET_UNSEEN_PLDP_NOTIFICATIONS,
    //    uid: this.props.userdetails[0].uid,
    //    companyID: this.props.userdetails[0].companyID
    // });
    // -------------------------------------------------

    if (Object.keys(this.props.followingData).length > 0) {
    } else {

      this.props.fetchUserData({
        type: 'FOLLOWING_BUTTON',
        userID: this.props.userdetails[0].userID,
        companyID: this.props.userdetails[0].companyID
      })
    }

    // this.props.fetchUserData({
    //   type: "FOLLOWING_BUTTON",
    //   userID: this.props.userdetails[0].userID,
    //   companyID: this.props.userdetails[0].companyID
    // });

    this.props.fetchCompanyData({
      type: 'FETCHED_COMPANY_DATA',
      companyID: this.props.userdetails[0].companyID
    })

    this.props.fetchUserData({
      type: 'UPDATE_MY_FOLLOWERS',
      userID: this.props.userdetails[0].userID,
      companyID: this.props.userdetails[0].companyID
    })

    this.props.updateLoggedUser({
      user: this.props.userdetails[0]
    })
    // }
  };

  updateBackup = () => {
    if (this.props.UPDATE_USER === 'LOG_UPDATE_USER_SUCCESS') {
      let params = {
        type: USER_ANALYTICS
      }
      this.props.clearStates({ type: 'CLEAR_UPDATE_USER_SUCCESS' })

      this.props.fetchUserData_users(params)
      this.props.fetchUserData_users({
        type: GET_UNSEEN_NOTIFICATIONS,
        userID: this.props.userdetails[0].userID,
        companyID: this.props.userdetails[0].companyID
      })
      this.props.fetchUserData_users({
        type: GET_UNSEEN_GROUP_NOTIFICATIONS,
        userID: this.props.userdetails[0].userID,
        companyID: this.props.userdetails[0].companyID
      })
      this.props.fetchUserData_users({
        type: GET_UNSEEN_PLDP_NOTIFICATIONS,
        userID: this.props.userdetails[0].userID,
        companyID: this.props.userdetails[0].companyID
      })
      this.props.fetchUserData_users({
        type: 'FOLLOWING_BUTTON',
        userID: this.props.userdetails[0].userID,
        companyID: this.props.userdetails[0].companyID
      })
      this.props.fetchCompanyData({
        type: 'FETCHED_COMPANY_DATA',
        companyID: this.props.userdetails[0].companyID
      })
      this.props.fetchUserData_users({
        type: 'UPDATE_MY_FOLLOWERS',
        userID: this.props.userdetails[0].userID,
        companyID: this.props.userdetails[0].companyID
      })
    }
    // var params = {
    //   type: UPDATE_SURVEY,
    //   companyID: this.props.userdetails[0].companyID
    //   };
    //   this.props.updateSurvey(params);
  };

  componentWillUnmount() {
    // Clean up listener when component unmounts
    const uid = this.props.userdetails[0].uid; // Assuming uid is in userdetails
    if (uid) {
      const mevNoteRef = firebase.database.ref(`/user/${uid}/MEVnote`);
      mevNoteRef.off("value"); // Remove listener
    }
  }

  // setupMEVNoteListener() {
  //   const uid = this.props.userdetails[0].uid; // Assuming uid is in userdetails
  //   const mevNoteRef = firebase.database.ref(`/user/${uid}/MEVnote`);

  //   mevNoteRef.on("value", (snapshot) => {
  //     const mevNote = snapshot.val();

  //     if (mevNote && mevNote!="." && mevNote!==".") {
  //         const hasRefreshed = localStorage.getItem("mevProcessCompleted");

  //         if (mevNote === "PROCESS COMPLETED." && !hasRefreshed) {
  //        // await new Promise(resolve => setTimeout(resolve, 7000));  
  //         ////////////////////////////////////////////////////////////////////////   
  //           window.location.reload();
  //          // return;
  //         ////////////////////////////////////////////////////////////////////////
  //       }
  //       // Trigger toast notification based on the update
  //       let paramsX = {
  //         type: "SHOW_TOAST",
  //         open: true,
  //         variant: mevNote.includes("Error") ? "error" : "success", // Error or success based on message
  //         message: mevNote,
  //       };
  //       this.props.showToast(paramsX); // Show toast without state update
  //     }
  //   }, (error) => {
  //   });
  // }

  setupMEVNoteListener() {
    const uid = this.props.userdetails[0].uid;
    const mevNoteRef = firebase.database.ref(`/user/${uid}/MEVnote`);
  
    mevNoteRef.on(
      "value",
      (snapshot) => {
        const mevNote = snapshot.val();
  
        if (mevNote && mevNote !== "." && mevNote !== ".." ) {
          const hasRefreshed = localStorage.getItem("mevProcessCompleted");
  
          // Map mevNote to progress percentage
          let progressValue = 0;
          let showProgress = true;
  
          switch (mevNote) {
            case "Preparing your MEV purchase...":
              progressValue = 5;
              break;
            case "MEV Purchase Approved":
              progressValue = 8;
              break;
            case "Converting Lc to BNB":
              progressValue = 12;
              break;
            case "Calculating BNB to send to patron wallet":
              progressValue = 18;
              break;
            case "Initial BNB transferred to user wallet":
              progressValue = 22;
              break;
            case "Additional BNB transferred to user wallet":
              progressValue = 28;
              break;
            case "Total BNB transferred to user wallet":
              progressValue = 33;
              break;
            case "BNB transfer to safe wallet successful":
              progressValue = 37;
              break;
            case "Preparing your coin purchase, please wait...":
              progressValue = 40;
              break; 
            case "SUCCESS! MEV coin purchase Successful. Please wait while We finalize details.":
              progressValue = 60;
              break;
            case "Setting rates and MEV coin price.":
              progressValue = 70;
              break;
            case "Almost finished! Updating Database.":
              progressValue = 80;
              break;
            case "PROCESS COMPLETED":
              progressValue = 99;
              break;
            case ".":
              progressValue = 100;
              break;
            default:
              if (mevNote.includes("Error")) {
                progressValue = 0; // Reset on error
                showProgress = false; // Hide progress bar on error
              } else {
                progressValue = this.state.progress; // Keep current progress if unknown message
              }
          }
  
          // Update state with progress
          this.setState({ progress: progressValue, showProgress });
  
          if (mevNote === "PROCESS COMPLETED" && !hasRefreshed) {
            setTimeout(() => {
            //  window.location.reload();
            }, 2000); // Delay reload to show 100% briefly
            localStorage.setItem("mevProcessCompleted", "true");
          }
  
          // Trigger toast notification
          let paramsX = {
            type: "SHOW_TOAST",
            open: true,
            variant: mevNote.includes("Error") ? "error" : "success",
            message: mevNote,
          };
          this.props.showToast(paramsX);
        } else {
          // Hide progress bar if no valid message
          this.setState({ showProgress: false });
        }
      },
      (error) => {
        
        this.setState({ showProgress: false }); // Hide on error
      }
    );
  }

  async checkTransactionFeasibility() {
    const { userdetails } = this.props;
    const userLCReady = parseInt(userdetails[0].points || 1);
    const LcInUSD = Number(userLCReady / 100);
    

    this.buyApproved = await this.canPerformMEVTransaction(LcInUSD); // Assign directly to class property
    

    // Optional: Force a re-render if you need the UI to update immediately
    this.forceUpdate(); // This triggers a re-render without state
  }

  // // Function to check if there’s enough BNB and MEV for the transaction
  async canPerformMEVTransaction(amountInUSD) {
    try {
      // Step 1: Fetch MEVinfo from Firebase Realtime Database
      //const mevInfoRef = ref(db, "MEVinfo");
     // const snapshot = await get(mevInfoRef);

      const userRef = firebase.database.ref('MEVinfo');
          const snapshot = await userRef.once('value');

      if (!snapshot.exists()) {
        
        return false;
      }
  
      const mevInfo = snapshot.val();
      const { MEVav, WALLETA, MEVprice, BNB_PRICE_IN_USD } = mevInfo;
  
      // Convert values to BigNumber for precise calculations
      const mevAvailable = new BigNumber(MEVav); // MEV tokens available
      const bnbAvailable = new BigNumber(WALLETA); // BNB available
      const mevPriceInUSD = new BigNumber(MEVprice); // MEV price in USD
      const transactionAmountUSD = new BigNumber(amountInUSD); // Amount in USD
      const BNBPRICEInUSD = BNB_PRICE_IN_USD;
      // Step 2: Calculate required BNB and MEV
      const requiredBNB = transactionAmountUSD.dividedBy(BNBPRICEInUSD); // BNB needed for the transaction
      const requiredMEV = transactionAmountUSD.dividedBy(mevPriceInUSD); // MEV tokens needed
  
      // Step 3: Check if there’s enough BNB in WALLETA
      if (bnbAvailable.isLessThan(requiredBNB)) {
        
        return false;
      }
  
      // Step 4: Check if there’s enough MEV in the sale contract
      if (mevAvailable.isLessThan(requiredMEV)) {
        
        return false;
      }
  
      // Step 5: All checks passed
      
      return true;
  
    } catch (error) {
      
      return false;
    }
  }

  //function to convert pledge to Level
  convertToLev = (inPoints) => {
    let points = parseInt(inPoints)
    let result
    if (points < 0) {
      result = 'Level 0'
    }    
    if (points >= 0 && points < 396) {
      result = 'Level 0'
    }
    if (points >= 396 && points < 968) {
      result = 'Level 1'
    }
    if (points >= 968 && points < 1936) {
      result = 'Level 2'
    }
    if (points >= 1936 && points < 4400) {
      result = 'Level 3'
    }
    if (points >= 4400 && points < 6160) {
      result = 'Level 4'
    }
    if (points >= 15000 && points < 8800) {
      result = 'Level 5'
    }
    if (points >= 8800 && points < 17600) {
      result = 'Level 6'
    }
    if (points >= 17600 && points < 38720) {
      result = 'Level 7'
    }
    if (points >= 38720 && points < 79200) {
      result = 'Level 8'
    }
    if (points >= 79200 && points < 132000) {
      result = 'Level 9'
    }
    if (points >= 132000 && points < 202400) {
      result = 'Level 10'
    }
    if (points >= 202400) {
      result = 'Level 11'
    }
    // if (points > 21000) {
    //   result = 'Level 6'
    // }
    return result
  }

  //convert points
  // convertToLev = (inPoints) => {
  //   let points = parseInt(inPoints)
  //   let result
  //   if (points < 0) {
  //     result = 'Level 0'
  //   }    
  //   if (points >= 0 && points <= 2999) {
  //     result = 'Level 0'
  //   }
  //   if (points >= 3000 && points <= 5999) {
  //     result = 'Level 1'
  //   }
  //   if (points >= 6000 && points <= 8999) {
  //     result = 'Level 2'
  //   }
  //   if (points >= 9000 && points <= 11999) {
  //     result = 'Level 3'
  //   }
  //   if (points >= 12000 && points <= 14999) {
  //     result = 'Level 4'
  //   }
  //   if (points >= 15000 && points <= 17999) {
  //     result = 'Level 5'
  //   }
  //   if (points >= 18000) {
  //     result = 'Level 6'
  //   }
  //   // if (points > 21000) {
  //   //   result = 'Level 6'
  //   // }
  //   return result
  // }

  render() {
    const {
      classes,
      useranalytics,
      userdetails,
      followingData,
      update_Survey
    } = this.props
    const { pledge } = this.state;

    //const userLCReady = parseInt(this.props.userdetails[0].points || 1); 
    //const LcInUSD = Number(userLCReady / 100);
    // if (this.buyApproved === null) {
    //   return <div>Loading transaction feasibility...</div>;
    // }

    return (
      <React.Fragment>
        <CardHeader
          classes={{
            root: classes.cardHeader,
            title: classes.title,
            avatar: classes.avatar,
            subheader: classes.subheader
          }}
          avatar={
            <Grid container justify='left' alignItems='center'>
              {userdetails && userdetails.length > 0 ? (
                <Avatar
                  component={Link}
                  to='/userprofile'
                  alt={userdetails[0].firstName}
                  src={PHOTO_PROFILE(userdetails[0].photoURL)}
                  className={classes.bigAvatar}
                  onClick={this.toggleDrawer}
                />
              ) : (
                <Avatar
                  alt='profile'
                  src={PHOTO_PROFILE('')}
                  className={classes.bigAvatar}
                  onClick={this.toggleDrawer}
                />
              )}
              <IconButton
                component={Link}
                to='/userprofile'
                aria-label='Edit profile'
                className={classes.editprofile}
                onClick={this.toggleDrawer}
              >
                <CreateIcon fontSize='small' />
              </IconButton>
            </Grid>
          }
          // TODO: Fix Issue if This returns undefined.
          title={
            userdetails.length > 0
              ? userdetails[0].firstName + ' ' + userdetails[0].lastName
              : ''
          }

          // subheader={
          //   userdetails.length > 0 && userdetails[0].points ? (
          //     <>
          //       <div className={classes.points}>
          //         {this.convertToLev(userdetails[0].points) === 'Level 0' ? (
          //           <BiPyramid fontSize='1.5em' />
          //         ) : this.convertToLev(userdetails[0].points) === 'Level 1' ? (
          //           <BiHive fontSize='1.5em' />
          //         ) : this.convertToLev(userdetails[0].points) === 'Level 2' ? (
          //           <BiArch fontSize='1.5em' />
          //         ) : this.convertToLev(userdetails[0].points) === 'Level 3' ? (
          //           <BiAperture fontSize='1.5em' />
          //         ) : this.convertToLev(userdetails[0].points) === 'Level 4' ? (
          //           <BiAnchor fontSize='1.5em' />
          //         ) : this.convertToLev(userdetails[0].points) === 'Level 5' ? (
          //           <BiMagnet fontSize='1.5em' />
          //         ) : this.convertToLev(userdetails[0].points) === 'Level 6' ? (
          //           <BiCrown fontSize='1.5em' />
          //         ) : null}

           subheader={
             userdetails.length > 0 && userdetails[0].points ? (
               <>
            <div className={classes.points}>
                {this.convertToLev(pledge) === 'Level 0' ? <BiPyramid fontSize="1.5em" />
                :this.convertToLev(pledge) === 'Level 1' ? <BiHive fontSize="1.5em" />
                  : this.convertToLev(pledge) === 'Level 2' ? <BiArch fontSize="1.5em"/>
                    : this.convertToLev(pledge) === 'Level 3' ? <BiAperture fontSize="1.5em"/>
                      : this.convertToLev(pledge) === 'Level 4' ? <BiAnchor fontSize="1.5em" />
                        : this.convertToLev(pledge) === 'Level 5' ? <BiMagnet fontSize="1.5em"/>
                          : this.convertToLev(pledge) === 'Level 6' ? <BiCrown fontSize="1.5em" />
                            : this.convertToLev(pledge) === 'Level 7' ? <BiStar fontSize="1.5em" />
                             : this.convertToLev(pledge) === 'Level 8' ? <BiSun fontSize="1.5em" />
                              : this.convertToLev(pledge) === 'Level 9' ? <BiShieldAlt fontSize="1.5em" />
                                : this.convertToLev(pledge) === 'Level 10' ? <BiDiamond fontSize="1.5em" />
                                 : this.convertToLev(pledge) === 'Level 11' ? <BiTrophy fontSize="1.5em" />
                            : null}


                  {/* {`${this.convertToLev((
                    parseInt(this.props.userdetails[0].points || 1))/100
                  )}  (${
                    (parseInt(this.props.userdetails[0].points || 1))/100
                  } Lc)`} */}

                 {`${this.convertToLev((
                    parseFloat(this.state.livepoints || 1))/100
                  )}  (${
                    ((parseFloat(this.state.livepoints || 1))/100).toFixed(4)
                  } Lc)`}

                </div>

            <Link
              style={{ textDecoration: 'none' }}
              to={{
                pathname: '/mevcoin',
                state: {
                  Everyone: 'xx=x=x=x'
                }
              }}
            >

                <div style={{ display: 'flex', alignItems: 'center', gap: '30px', marginTop: '0px' }}> 

                <span style={{ lineHeight: '1', display: 'inline-flex', alignItems: 'center', color: 'black' }}>
                  {/* {userdetails[0].mevInWallet 
                    ? parseFloat(userdetails[0].mevInWallet).toFixed(1) + ' MEV' 
                    : ''} */}
                   {this.state.liveMEV 
                    ? parseFloat(this.state.liveMEV).toFixed(1) + ' MEV' 
                    : ''} 

                </span>
                {/* MEV Coin button - always visible for all users */}
                <span style={{ lineHeight: '1', display: 'inline-flex', alignItems: 'center' }}>
                <IconButton
                  aria-label="MEV Coins"
                  className={classes.editprofile}
                  onClick={() => {
                    // Call navigation handler if security level is level3
                    if (
                      userdetails[0]?.securityLevel === "level3" ||
                      userdetails[0]?.defaultSecurityLevel === "level3"
                    ) {
                      this.handleWhatsAppOTPClick();
                    }
                    // Close the sidebar
                    this.props.toggleDrawer()
                   // this.toggleDrawer; // Adjust based on your close function name
                  }}
                  size="small"
                  style={{
                    padding: 0,
                    display: "flex",
                    marginTop: "20px",
                    position: "relative",
                  }}
                  title={
                    userdetails[0]?.securityLevel === "level3" ||
                    userdetails[0]?.defaultSecurityLevel === "level3"
                      ? "Level 3: WhatsApp OTP & MEV Coins"
                      : "MEV Coins"
                  }
                >
                  <img src={mevIcon} alt="MEV Coin" style={{ width: "40px", height: "40px" }} />
                 
                  {/* Only show WhatsApp OTP overlay for Level 3 users */}
                  {(userdetails[0]?.securityLevel === "level3" ||
                    userdetails[0]?.defaultSecurityLevel === "level3") && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-2px",
                        right: "-2px",
                        fontSize: "10px",
                        background: "#25D366",
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      📱
                    </span>
                  )}
                </IconButton>

                </span>
                </div>
                </Link>

                <div>{/* {userdetails[0].companyName} */}</div>
              </>
            ) : null // userdetails[0].companyName
          }     
        />

    {/* Progress Bar */}
    {/* {this.state.showProgress && (
      <div style={{ width: '100%', margin: '10px 0' }}>
         <LinearProgress
          variant="determinate"
          value={this.state.progress}
          classes={{ root: classes.progress, bar: classes.progressBar }}
        /> 
      </div>
    )} */}
 
        <div className={classes.followers}>
          <div
            option='followers'
            className={classes.follow}
            onClick={this.handleOpenFollowersDialog.bind(this)}
          >
            <Chip
              label={
                Object.keys(useranalytics).length > 0
                  ? useranalytics.followers
                  : 0
              }
              className={classes.chip}
              variant='default'
            />
            &nbsp;
            <Typography className={classes.typfont} variant='body2'>
              Followers
            </Typography>
          </div>
          <div
            option='following'
            className={classes.follow}
            onClick={this.handleOpenFollowersDialog.bind(this)}
          >
            <Chip
              label={
                Object.keys(useranalytics).length > 0
                  ? useranalytics.following
                  : 0
              }
              className={classes.chip}
              variant='default'
            />
            &nbsp;
            <Typography className={classes.typfont} variant='body2'>
              Following
            </Typography>
          </div>
        </div>
        <FollowingDialog
          open={this.state.openFollowing}
          option={this.state.option}
          onOpenFollowersDialog={this.handleOpenFollowersDialog}
        />

        {/* WhatsApp OTP Dialog */}
        <WhatsAppOTPDialog
          open={this.state.showWhatsAppOTPDialog}
          onClose={this.handleCloseWhatsAppOTPDialog}
          userID={this.props.userdetails[0]?.userID}
          onVerificationSuccess={this.handleWhatsAppOTPVerificationSuccess}
        />
      </React.Fragment>
    )
  }
}

const LoggedInUser = withStyles(styles)(LoggedUser)

LoggedUser.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchUserData: PropTypes.func.isRequired,
  fetchUserData_users: PropTypes.func.isRequired,
  fetchCompanyData: PropTypes.func.isRequired,
  fetchUserData_con: PropTypes.func.isRequired,
  useranalytics: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    useranalytics: state.userdata.useranalytics,
    userdetails: state.userDialog.userDetails,
    followingData: state.userdata.followingButton,
    UPDATE_USER: state.userDialog.UPDATE_USER,
    update_Survey: state.updateSurvey.update_Survey,
   // singleBool: state.simpleVal2.simplething2
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserData: (params) => dispatch(fetchUserData(params)),
    fetchUserData_users: (params) => dispatch(fetchUserData_users(params)),
    updateLoggedUser: (params) => dispatch(updateLoggedUser(params)),
    fetchCompanyData: (params) => dispatch(fetchCompanyData(params)),
    fetchUserData_con: (params) => dispatch(fetchUserData_con(params)),
    clearStates: (params) => dispatch(clearStates(params)),
    updateSurvey: (params) => dispatch(updateSurvey(params)),
    showToast: params => dispatch(showToast(params)),
    sendWhatsAppOTP: (userID) => sendWhatsAppOTP(userID),
   // simpleAction2: params => dispatch(simpleAction2(params))
    // showUserProfile: params => dispatch(showUserProfile(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoggedInUser)
